module.exports = __webpack_public_path__ + "static/media/bata-1.dc38fa55.jpeg";